<template>
    <el-drawer title="生成兑换码" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="auto" @close="close">
        <div class="drawer-content">
            <el-alert type="warning" :closable="false" v-if="data">
                <span slot="title">优惠券名称: {{ data.name }}</span>
            </el-alert>
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" class="MT10">				
                <el-form-item  prop="num" label="生成兑换码数量">
                    <el-input-number style="width:100%" v-model="formData.num" :min="1" :max="10000" :precision="0"
                        placeholder="请输入生成兑换码数量"></el-input-number>
                </el-form-item>
				<el-form-item prop="deadlineTime" label="兑换截止时间" >
				    <el-date-picker v-model="formData.deadlineTime" type="datetime" placeholder="请填写兑换截止时间" value-format="yyyy-MM-dd HH:mm:ss" size="medium"></el-date-picker>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    num: undefined,
    couponRuleId:'',
	deadlineTime:''
}
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: ''
        },
    },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultFormData
            },
            rules: {                
                num: [{ required: true, message: "请输入数量" }],
				deadlineTime: [{ required: true, message: "请填写兑换截止时间" }],
            },
            data: null,
        }
    },
    methods: {
        close() {
            this.formData = { ...defaultFormData };
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data) {
            this.data = data;
			if( data ){
				 this.formData.deadlineTime = data.endTime.split(' ')[0] + ' 00:00:00';
				 this.formData.couponRuleId = data.id
			}            
            this.drawerShow = true;
        },
       
        //表单提交
        submitForm() {
			
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const res = await this.$request({
                        url: '/coupon/redeem/create',
                        params: { ...this.formData},
                        method: "post",
                    }).catch(() => {
                        this.$message.error("操作失败,请重试");
                    }).finally(() => {
                        this.btnLoading = false;
                    });

                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$emit('onUpdate');
                        this.close();
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                } else {
                    return false;
                }
            });
        },
    }
}
</script>